import {
  BulkUpdatePayload,
  NotificationSettingsResponse,
  NotificationType,
  UpdateGlobalSettingsPayload,
  UpdatePreferencePayload,
} from '@/@types/Notifications';
import { api } from './api';

export const NotificationsService = {
  getSettings: async (): Promise<NotificationSettingsResponse> => {
    const response = await api.get<NotificationSettingsResponse>('/v1/notification-settings');
    return response.data;
  },

  updateGlobalSettings: async (payload: UpdateGlobalSettingsPayload): Promise<NotificationSettingsResponse> => {
    const response = await api.put<NotificationSettingsResponse>('/v1/notification-settings/global', payload);
    return response.data;
  },

  updatePreference: async (
    type: NotificationType,
    payload: UpdatePreferencePayload
  ): Promise<NotificationSettingsResponse> => {
    const response = await api.put<NotificationSettingsResponse>(
      `/v1/notification-settings/${type}`,
      payload
    );
    return response.data;
  },

  bulkUpdate: async (payload: BulkUpdatePayload): Promise<NotificationSettingsResponse> => {
    const response = await api.put<NotificationSettingsResponse>(
      '/v1/notification-settings/bulk',
      payload
    );
    return response.data;
  },
};
